/**
 * Porté à l'identique depuis apps/web/components/home/SeoIntro.tsx (aucune
 * dépendance Next.js dans l'original — contenu statique).
 */
export function SeoIntro() {
  return (
    <section className="container-vvs py-8 lg:py-10">
      <details open className="group rounded-sm border border-line bg-white p-5">
        <summary className="cursor-pointer list-none font-display text-base font-semibold text-navy [&::-webkit-details-marker]:hidden">
          <span className="inline-flex items-center gap-2">
            À propos de Vendez-Vous eShop
            <span aria-hidden="true" className="text-gold transition-transform group-open:rotate-180">
              ▾
            </span>
          </span>
        </summary>

        <div className="mt-4 space-y-4 font-body text-sm leading-relaxed text-muted">
          <div>
            <h2 className="font-display text-sm font-semibold text-ink">
              Bienvenue sur le marketplace généraliste de référence en Côte d&apos;Ivoire
            </h2>
            <p className="mt-1">
              VVS — Vendez-Vous eShop réunit en un seul panier des univers que l&apos;on trouve
              d&apos;habitude sur des boutiques séparées&nbsp;: bijoux &amp; montres, mode &amp;
              accessoires, beauté &amp; parfums, électronique &amp; high-tech, maison &amp; déco,
              enfants &amp; bébé. Une sélection contrôlée, des vendeurs vérifiés, et une seule
              expérience d&apos;achat du début à la fin.
            </p>
          </div>

          <div>
            <h2 className="font-display text-sm font-semibold text-ink">
              Payez comme vous en avez l&apos;habitude
            </h2>
            <p className="mt-1">
              Paiement à la livraison ou par mobile money, livraison rapide à Abidjan et dans les
              grandes villes de Côte d&apos;Ivoire&nbsp;: c&apos;est le mode de fonctionnement le
              plus naturel sur ce marché, et c&apos;est celui que VVS a choisi dès le départ,
              plutôt que d&apos;imposer un parcours pensé pour un autre pays.
            </p>
          </div>

          <div>
            <h2 className="font-display text-sm font-semibold text-ink">Comment commander sur VVS&nbsp;?</h2>
            <p className="mt-1">
              Parcourez les rayons ou utilisez la recherche, choisissez vos articles, renseignez
              votre commune de livraison pour connaître les frais exacts, puis validez votre
              commande. Un conseiller vous appelle ensuite pour la confirmer avant expédition — une
              étape simple qui évite les mauvaises surprises, pour vous comme pour nous.
            </p>
          </div>
        </div>
      </details>
    </section>
  );
}
